import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { useStoreData } from '../../../hooks/useStoreData'
import Input from '../../../components/Input'
import Button from '../../../components/Button'
import { ApiRoutes } from '../../../services/ApiService'
import { showToast } from '../../../services/ToastService'
import { Fulfiller } from '../../../types/Fulfiller'

type CreateFulfillerModalProps = {
    onSubmit?: () => void
}

const CreateFulfillerModal: React.FC<CreateFulfillerModalProps> = ({
    onSubmit,
}) => {
    const { t } = useTranslation(['settings'])

    const storeFulfillerSchema = useMemo(() => {
        return {
            email: yup.string().required().min(3),
            password: yup.string().required().min(3),
        }
    }, [])

    const { element, isValid, changeProp, submit } = useStoreData<Fulfiller>(
        ApiRoutes.FULFILLER,
        storeFulfillerSchema
    )

    const submitCategory = () => {
        submit()
            .then((res) => {
                if (res.status === 201) {
                    if (onSubmit) onSubmit()
                    changeProp({ email: '', password: '' })
                    showToast(t('fulfillment.create_modal.success'))
                } else {
                    showToast(t('fulfillment.create_modal.error'), 'error')
                }
            })
            .catch(() => {
                showToast(t('fulfillment.create_modal.error'), 'error')
            })
    }

    return (
        <div>
            <Input
                type={'text'}
                placeholder={t('fulfillment.labels.email')}
                property={'email'}
                value={element.email ?? ''}
                onChange={(_, value) => changeProp({ email: value })}
                classes={'zr-my-4 zr-mr-4'}
            />
            <Input
                type={'password'}
                placeholder={t('fulfillment.labels.password')}
                property={'password'}
                value={element.password ?? ''}
                onChange={(_, value) => changeProp({ password: value })}
                classes={'zr-my-4 zr-mr-4'}
            />

            <Button
                hierarchy={'primary'}
                text={t('fulfillment.create_modal.action')}
                classes={'zr-w-100 zr-mr-4'}
                fn={submitCategory}
                disabled={!isValid}
            />
        </div>
    )
}

export default CreateFulfillerModal
